<template>
  <div :class="['dropdown', variant === 'vertical' ? 'profile-action' : 'dropdown-action']">
    <a
      v-if="variant === 'vertical'"
      href="javascript:;"
      class="action-icon dropdown-toggle"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="material-icons">more_vert</i>
    </a>
    <a
      v-else
      href="javascript:;"
      class="dropdown-toggle mb-0 user-name-link"
      :class="{ 'text-black': variant === 'activity', 'text-decoration-none': true, 'no-truncate': !truncate }"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :title="employee.name"
    >
      {{ employee.name }}
    </a>
    <div class="dropdown-menu dropdown-menu-right">
      <a
        v-if="showViewProfile"
        href="javascript:;"
        class="dropdown-item"
        @click="openIframe({ name: 'EmployeeProfile', params: { id: (employee.id || employee.user_id) } })"
      >
        <i class="fa-solid fa-eye m-r-5"></i> View Profile
      </a>
      <a
        class="dropdown-item"
        href="javascript:;"
        data-bs-toggle="modal"
        data-bs-target="#edit_employee"
        @click="$emit('edit', employee)"
      >
        <i class="fa-solid fa-pencil m-r-5"></i> Edit
      </a>
      <a
        v-if="isAdmin && (employee.account_type === 'MANAGER' || employee.account_type === 'SITE MANAGER')"
        class="dropdown-item"
        href="javascript:;"
        data-bs-toggle="modal"
        data-bs-target="#assign_employee_modal"
        @click="$emit('assign-employee', employee)"
      >
        <i class="fa-solid fa-user-group m-r-5"></i> Assign Employee
      </a>
      <a class="dropdown-item" href="javascript:;" @click="openIframe({ path: '/employee/leaves-employee', query: { id: (employee.id || employee.user_id) } })">
        <i class="fa-solid fa-arrow-left m-r-5"></i> Leaves
      </a>
      <a class="dropdown-item" href="javascript:;" @click="openIframe({ path: '/employee/attendance-employee', query: { id: (employee.id || employee.user_id) } })">
        <i class="fa fa-calendar m-r-5"></i> Attendance
      </a>
      <a
        class="dropdown-item"
        href="javascript:;"
        data-bs-toggle="modal"
        data-bs-target="#sick_leave"
        @click="$emit('sick-leave', employee)"
      >
        <i class="fa fa-right-from-bracket m-r-5"></i> Sick Leave
      </a>
      <a
        v-if="showMonitor"
        class="dropdown-item"
        href="javascript:;"
        @click="$emit('toggle-monitoring', employee)"
      >
        <i class="fa fa-street-view m-r-5"></i>
        {{ employee.is_monitored ? monitoringText.monitored : monitoringText.monitor }}
      </a>
      <a
        class="dropdown-item"
        href="javascript:;"
        data-bs-toggle="modal"
        data-bs-target="#face_template"
        @click="$emit('add-face-template', employee)"
      >
        <i class="fa-solid fa-plus m-r-5"></i> Add Face Template
      </a>
      <a v-if="reportAsEvent" class="dropdown-item" href="javascript:;" @click="$emit('report', employee)">
        <i class="fa fa-th m-r-5"></i> Employee Report
      </a>
      <a
        v-else
        class="dropdown-item"
        href="javascript:;"
        @click="openIframe({ name: 'employeeReport', params: { id: (employee.id || employee.user_id) } })"
      >
        <i class="fa fa-th m-r-5"></i> Employee Report
      </a>
      <a class="dropdown-item" href="javascript:;" @click="$emit('face-templates', employee)">
        <i class="fa-solid fa-id-badge m-r-5"></i> Face Templates
      </a>
      <a
        class="dropdown-item"
        href="javascript:;"
        data-bs-toggle="modal"
        data-bs-target="#reset_password_modal"
        @click="$emit('reset-password', employee)"
      >
        <i class="fa-solid fa-key m-r-5"></i> Reset Password
      </a>
      <a
        class="dropdown-item"
        href="javascript:;"
        @click="openIframe({ path: '/employee/shift-scheduling', query: { id: (employee.id || employee.user_id) } })"
      >
        <i class="fa-solid fa-clock m-r-5"></i> Schedule
      </a>
      <a
        class="dropdown-item"
        href="javascript:;"
        data-bs-toggle="modal"
        data-bs-target="#view_banked_time_details_modal"
        @click="$emit('banked-time', employee)"
      >
        <i class="fa-solid fa-clock-rotate-left m-r-5"></i> Banked Time
      </a>
      <a
        class="dropdown-item"
        href="javascript:;"
        @click="openIframe({ path: '/employee/activity', query: { id: (employee.id || employee.user_id) } })"
      >
        <i class="fa-solid fa-chart-line m-r-5"></i> Activity
      </a>
      <a
        v-if="!employee.deactivated_at && employee.scheduled_deactivation_date"
        class="dropdown-item text-warning"
        href="javascript:;"
        @click="$emit('cancel-deactivation', employee)"
      >
        <i class="fa-solid fa-ban m-r-5"></i> Cancel Scheduled Deactivation
      </a>
      <a
        v-if="!employee.deactivated_at"
        class="dropdown-item text-danger"
        href="javascript:;"
        @click="$emit('deactivate', employee)"
      >
        <i class="fa-regular fa-trash-can m-r-5"></i> {{ employee.scheduled_deactivation_date ? 'Reschedule Deactivation' : 'Deactivate' }}
      </a>
      <a
        v-else
        class="dropdown-item text-success"
        href="javascript:;"
        @click="$emit('activate', employee)"
      >
        <i class="fa-solid fa-user-check m-r-5"></i> Activate
      </a>
      <template v-for="(item, index) in customItems" :key="index">
        <a
          class="dropdown-item"
          href="javascript:;"
          @click="$emit('custom-action', { action: item.action, employee: employee })"
        >
          <i :class="[item.icon, 'm-r-5']"></i> {{ item.label }}
        </a>
      </template>
    </div>

    <!-- Iframe Overlay -->
    <teleport to="body">
        <div v-if="iframeUrl" class="iframe-overlay">
            <div class="iframe-header">
                <button type="button" class="btn btn-outline-light text-white rounded-circle btn-sm" @click="iframeUrl = null">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <iframe :src="iframeUrl" class="report-iframe"></iframe>
        </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: 'ActionDropdown',
  props: {
    employee: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: 'vertical', // 'vertical', 'text', 'activity'
    },
    showViewProfile: {
      type: Boolean,
      default: false,
    },
    showMonitor: {
      type: Boolean,
      default: true,
    },
    monitoringText: {
      type: Object,
      default: () => ({
        monitor: 'Monitor',
        monitored: 'Monitored',
      }),
    },
    customItems: {
      type: Array,
      default: () => [],
    },
    reportAsEvent: {
      type: Boolean,
      default: false,
    },
    emitNavigations: {
      type: Boolean,
      default: false,
    },
    truncate: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['edit', 'leaves', 'attendance', 'sick-leave', 'toggle-monitoring', 'add-face-template', 'face-templates', 'report', 'custom-action', 'reset-password', 'assign-employee', 'banked-time', 'deactivate', 'activate', 'cancel-deactivation', 'profile', 'schedule', 'activity'],
  data() {
    return {
      iframeUrl: null
    };
  },
  computed: {
    isAdmin() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return userInfo && userInfo.is_admin === 1;
    }
  },
  methods: {
    openIframe(routeConfig) {
      const routeData = this.$router.resolve(routeConfig);
      const url = new URL(routeData.href, window.location.origin);
      this.iframeUrl = url.href;
    }
  }
};
</script>

<style scoped>
.iframe-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    background: #fff;
    display: flex;
    flex-direction: column;
}

.iframe-header {
    display: flex;
    justify-content: flex-end;
    padding: 5px 10px;
    margin-inline-end: 15px;
    background: linear-gradient(to right, #099bf8 0%, #0253cc 100%);
}

.report-iframe {
    flex-grow: 1;
    width: 100%;
    height: 100%;
    border: none;
    display: block;
}

.btn-outline-light:hover{
    color: #ffffff;
    background-color: transparent;
    border: 1px solid #fff;
}

.user-name-link {
    color: #212529;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 220px;
    vertical-align: middle;
}
.user-name-link.no-truncate,
.dropdown.no-truncate .user-name-link {
    max-width: none;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
}
.user-name-link:hover {
    color: #0d6efd;
}
</style>
